import styled from "@emotion/styled";

export const CustomQuoteLandingPageHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "20px 32px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	h1: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.main,
		margin: 0
	},
	button: {
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const CustomQuoteLandingPageContent = styled.div(({ theme }) => ({
	padding: "16px 20px"
}));
